import { IntlProvider } from 'react-intl';
import React from 'react';
import PropTypes, { string, shape } from 'prop-types';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import {
  addErrorToReport,
  loadLanguagePack,
} from '@americanexpress/one-app-ducks';
import { THEMES } from '@americanexpress/consumer-travel-base';
import { Surface } from '@americanexpress/dls-react';
import { composeModules } from 'holocron';
import TravelPackages from './TravelPackages';
import { CLASS_TYPES } from '../constants/flightConstants';
import {
  MODULE_NAME,
  MODULE_NAME_SEARCH_DATE_PICKER, MODULE_NAME_SEARCH_LOCATIONS, MODULE_NAME_SEARCH_REDIRECT,
  MODULE_NAME_SEARCH_ROOMS_TRAVELERS,
} from '../constants/packagesConstants';
import reducer from '../reducer';

const { THEME_BLUE, THEME_WHITE } = THEMES;

const TravelSearchPackagesWrapper = ({
  locale,
  languageData,
  theme,
  defaultFlightClass,
  id,
  route: {
    theme: routeTheme,
  },
}) => {
  const isBlueTheme = routeTheme === THEME_BLUE
    || (routeTheme === undefined && theme === THEME_BLUE);

  return (
    <IntlProvider locale={locale} messages={languageData} testId="intl-provider">
      <Surface variant={isBlueTheme ? 'fg-brand' : 'foreground'} className="radius-container-b">
        <TravelPackages
          defaultFlightClass={defaultFlightClass}
          id={id}
          theme={routeTheme || theme}
        />
      </Surface>
    </IntlProvider>
  );
};

export const loadModuleData = async ({ store: { dispatch } }) => {
  try {
    await Promise.allSettled([
      dispatch(loadLanguagePack(MODULE_NAME, { fallbackLocale: 'en-US' })),
      dispatch(composeModules([
        { name: MODULE_NAME_SEARCH_LOCATIONS },
        { name: MODULE_NAME_SEARCH_ROOMS_TRAVELERS },
        { name: MODULE_NAME_SEARCH_DATE_PICKER },
        { name: MODULE_NAME_SEARCH_REDIRECT },
      ])),
    ]);
  } catch (e) {
    await dispatch(addErrorToReport(e, {
      collectionMethod: 'loadModuleData',
      moduleID: MODULE_NAME,
    }));
    throw e;
  }
};

TravelSearchPackagesWrapper.propTypes = {
  id: PropTypes.string,
  locale: string.isRequired,
  languageData: shape({}).isRequired,
  defaultFlightClass: PropTypes.oneOf([
    CLASS_TYPES.ECONOMY,
    CLASS_TYPES.FIRST,
    CLASS_TYPES.BUSINESS,
    CLASS_TYPES.PREMIUM_ECONOMY,
  ]),
  theme: PropTypes.oneOf([THEME_BLUE, THEME_WHITE]),
  route: PropTypes.shape({
    theme: PropTypes.oneOf([THEME_BLUE, THEME_WHITE]),
  }),
};

TravelSearchPackagesWrapper.defaultProps = {
  id: MODULE_NAME,
  theme: THEME_WHITE,
  defaultFlightClass: CLASS_TYPES.ECONOMY,
  route: {
    theme: undefined,
  },
};

TravelSearchPackagesWrapper.holocron = {
  name: MODULE_NAME,
  loadModuleData,
  reducer,
};

export { TravelSearchPackagesWrapper as TestableTravelSearchPackagesWrapper };

export default oneAppModuleWrapper(MODULE_NAME)(TravelSearchPackagesWrapper);
